/** So'zlar ro'yxati (demo `wordList`): tinglash, so'z/tarjima, yulduzcha, quti darajasi. */
import type { Word } from '../data/types';
import { useStore } from '../store';
import { speak } from '../lib/speech';
import { Ic } from './Icon';
import { HardBtn } from './HardBtn';

export function WordList({ ws }: { ws: Word[] }) {
  const states = useStore((s) => s.w);
  if (!ws.length) return <p className="t13" style={{ margin: 0 }}>Hech narsa topilmadi.</p>;
  return (
    <div className="wl">
      {ws.map((w) => {
        const b = states[w.id]?.box ?? 0;
        return (
          <div className="wr" key={w.id}>
            <button className="spk" onClick={() => speak(w.w)} aria-label={`Tinglash: ${w.w}`}><Ic n="vol" /></button>
            <div className="grow"><b>{w.w}</b><span>{w.uz}</span></div>
            <HardBtn id={w.id} cls="mini" />
            <div className="lvl" title={b ? `${b}-quti` : 'Yangi'}>{[1, 2, 3, 4, 5, 6].map((i) => <i key={i} className={i <= b ? 'on' : ''} />)}</div>
          </div>
        );
      })}
    </div>
  );
}
